import React from "react";

export let EmailLink = ({ email, children, subject }) => {
    email = email || children
    subject = subject ? `&subject=${subject}` : ''
    return <a
        href={`mailto:${email}${subject}`}
        target={'_blank'}
    >{children || email}
    </a>

};

export let PhoneLink = ({ label, children }) => {
    return <a
        href={`tel:${children}`}
        target={'_blank'}
    >{label || children}
    </a>

};

